export enum LoadingStatus {
    Idle,
    Loading,
    Success,
    Failed,
}

export enum ReconnectingStatus {
    Idle,
    Reconnecting,
    Success,
    Failed,
}
